//-------------------------------
//フェイドイン
//-------------------------------
// IntersectionObserverのオプションを設定
const options = {
	rootMargin: '0px',
	threshold: 0.2,
};

jQuery(function ($) {
	const fadeIn = document.querySelectorAll(".js-in");

	// IntersectionObserverを呼び出し
	const observer = new IntersectionObserver(showElement, options);

	// fadeInクラスが付与されてる要素にたどり着いたらIntersectionObserverを実行
	fadeIn.forEach((fadeIn) => {
		observer.observe(fadeIn);
	});

	// 要素が表示されたら実行する動作
	function showElement(entries) {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				// 要素にactiveクラスを付与
				entry.target.classList.add("is-active");
			}
		});
	}
});

//-------------------------------
//順番にフェイドイン
//-------------------------------
jQuery(function ($) {
	const fadeIn = document.querySelectorAll(".fadeIn_list");

	const observer = new IntersectionObserver(showElement, options);

	fadeIn.forEach((fadeIn) => {
		observer.observe(fadeIn);
	});

	function showElement(entries) {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				entry.target.classList.add("show");
			}
		});
	}

});


//-------------------------------
//ずらしてフェイドイン
//-------------------------------
$(window).on("load", function () {
	//ロードしてからスライド
	$('.js-load').delay(1000).queue(function () {
		$(this).addClass('is-active').dequeue();
	});

	$('.js-load-more').delay(2000).queue(function () {
		$(this).addClass('is-active').dequeue();
	});
});

//-------------------------------
//予約ボタン
//-------------------------------
//-----------------
//PCの時
//-----------------
function initializeHeaderReserve() {
	// .p-front--firstview__innerの要素を取得
	const firstviewElement = document.querySelector('.p-front--firstview__inner');

	// .p-front--header__reserveの要素を取得
	const headerReserveElement = document.querySelector('.p-front--header__reserve');

	// .p-front--firstview__innerの領域を超えたかどうかを判定する関数
	function checkScrollPosition() {
		// .p-front--firstview__innerの領域の下端の位置を取得
		const firstviewBottom = firstviewElement.getBoundingClientRect().bottom + window.scrollY;

		// ウィンドウのスクロール位置を取得
		const scrollPosition = window.scrollY || window.pageYOffset;

		// .p-front--firstview__innerの領域を超えた場合
		if (scrollPosition > firstviewBottom) {
			// .p-front--header__reserveにopacity: 1とpointer-events: allを追加
			headerReserveElement.style.opacity = '1';
			headerReserveElement.style.pointerEvents = 'all';
		} else {
			// .p-front--header__reserveからopacity: 1とpointer-events: allを削除
			headerReserveElement.style.opacity = '0';
			headerReserveElement.style.pointerEvents = 'none';
		}
	}

	// ページの読み込みが完了した時に初期状態をチェックする関数
	function checkInitialScrollPosition() {
		// .p-front--firstview__innerの領域の下端の位置を取得
		const firstviewBottom = firstviewElement.getBoundingClientRect().bottom + window.scrollY;

		// ウィンドウのスクロール位置を取得
		const scrollPosition = window.scrollY || window.pageYOffset;

		// ページ表示時に、.p-front--firstview__innerの領域を超えているかどうかを判定
		if (scrollPosition > firstviewBottom) {
			// .p-front--header__reserveにopacity: 1とpointer-events: allを追加
			headerReserveElement.style.opacity = '1';
			headerReserveElement.style.pointerEvents = 'all';
		} else {
			// .p-front--header__reserveからopacity: 1とpointer-events: allを削除
			headerReserveElement.style.opacity = '0';
			headerReserveElement.style.pointerEvents = 'none';
		}

		// ウィンドウのスクロールイベントを監視し、スクロール位置の変化に応じてcheckScrollPosition関数を呼び出す
		window.addEventListener('scroll', checkScrollPosition);
	}

	// ページの読み込みが完了した時にcheckInitialScrollPosition関数を呼び出す
	window.addEventListener('load', checkInitialScrollPosition);
}

// initializeHeaderReserve関数を呼び出してヘッダーの操作を初期化
initializeHeaderReserve();

//-----------------
//スマホの時
//-----------------
function initializeFooterBnr() {
	// .p-front--firstview__innerの要素を取得
	const firstviewElement = document.querySelector('.p-front--firstview__inner');

	// .p-front--footer-bnrの要素を取得
	const footerBnrElement = document.querySelector('.p-front--footer-bnr');

	// .p-front--firstview__innerの領域を超えたかどうかを判定する関数
	function checkScrollPosition() {
		// .p-front--firstview__innerの領域の下端の位置を取得
		const firstviewBottom = firstviewElement.getBoundingClientRect().bottom + window.scrollY;

		// ウィンドウのスクロール位置を取得
		const scrollPosition = window.scrollY || window.pageYOffset;

		// .p-front--firstview__innerの領域を超えた場合
		if (scrollPosition > firstviewBottom) {
			// .p-front--footer-bnrにopacity: 1とpointer-events: allを追加
			footerBnrElement.style.opacity = '1';
			footerBnrElement.style.pointerEvents = 'all';
		} else {
			// .p-front--footer-bnrからopacity: 1とpointer-events: allを削除
			footerBnrElement.style.opacity = '0';
			footerBnrElement.style.pointerEvents = 'none';
		}
	}

	// ページの読み込みが完了した時に初期状態をチェックする関数
	function checkInitialScrollPosition() {
		// ページの幅が最大767px以下の場合のみ実行
		if (window.innerWidth <= 767) {
			// .p-front--firstview__innerの領域の下端の位置を取得
			const firstviewBottom = firstviewElement.getBoundingClientRect().bottom + window.scrollY;

			// ウィンドウのスクロール位置を取得
			const scrollPosition = window.scrollY || window.pageYOffset;

			// ページ表示時に、.p-front--firstview__innerの領域を超えているかどうかを判定
			if (scrollPosition > firstviewBottom) {
				// .p-front--footer-bnrにopacity: 1とpointer-events: allを追加
				footerBnrElement.style.opacity = '1';
				footerBnrElement.style.pointerEvents = 'all';
			} else {
				// .p-front--footer-bnrからopacity: 1とpointer-events: allを削除
				footerBnrElement.style.opacity = '0';
				footerBnrElement.style.pointerEvents = 'none';
			}

			// ウィンドウのスクロールイベントを監視し、スクロール位置の変化に応じてcheckScrollPosition関数を呼び出す
			window.addEventListener('scroll', checkScrollPosition);
		}
	}

	// ページの読み込みが完了した時にcheckInitialScrollPosition関数を呼び出す
	window.addEventListener('load', checkInitialScrollPosition);
}

// initializeFooterBnr関数を呼び出してフッターバナーの操作を初期化
initializeFooterBnr();
